import moment from 'moment-timezone'
import { useSelector } from 'react-redux'

import { timeNotationSelector } from 'selectors/current_user'
import { formatTime } from 'services/time_format'

export const FormattedTime = ({ value }) => {
  const time = moment(value, 'hh:mm')
  const timeNotation = useSelector(timeNotationSelector)

  return formatTime(time, timeNotation)
}
